import BlockListOverview from "@/modules/blockList/views/BlockListView.vue";

export const DeniedPrefixRoutes = [
    {
        path: '/prefix/blocked',
        component: BlockListOverview,
    }
]